<template>
  <Section v-if="form.useAdvancedSetting" @back="$emit('back')">
    <v-layout>
      <v-flex xs3>
        <v-subheader>配信デバイス</v-subheader>
      </v-flex>
      <v-flex xs9 align-self-center>
        <template v-if="form.deliveryDevices">
          <v-chip
            v-for="device in form.deliveryDevices"
            :key="device"
            small
            outline
            color="blue"
          >
            <AppDevice :value="device" />
          </v-chip>
        </template>
        <span v-else>なし</span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs3>
        <v-subheader>配信面</v-subheader>
      </v-flex>
      <v-flex xs9 align-self-center>
        <template v-if="form.deliveryInventories">
          <v-chip
            v-for="inventory in form.deliveryInventories"
            :key="inventory"
            small
            outline
            color="blue"
          >
            <AppInventory :value="inventory" />
          </v-chip>
        </template>
        <span v-else>なし</span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs3>
        <v-subheader>端末言語</v-subheader>
      </v-flex>
      <v-flex xs9 align-self-center>
        <span v-if="form.onlyJapaneseDevice">日本語に限定する</span>
        <span v-else>限定しない</span>
      </v-flex>
    </v-layout>
    <v-layout column>
      <v-subheader>ユーザー属性設定</v-subheader>
      <v-layout pl-4>
        <v-flex xs3>
          <v-subheader>性別</v-subheader>
        </v-flex>
        <v-flex xs9 align-self-center>
          <v-chip v-if="demographic.sex" small outline color="blue">
            <AppSex :value="demographic.sex" />
          </v-chip>
          <span v-else>全て</span>
        </v-flex>
      </v-layout>
      <v-layout pl-4>
        <v-flex xs3>
          <v-subheader class="subtitle-2">年代</v-subheader>
        </v-flex>
        <v-flex xs9 align-self-center>
          <template v-if="demographic.age">
            <v-chip
              v-for="generation in demographic.age"
              :key="generation"
              small
              outline
              color="blue"
            >
              <AppDemographicAge :value="generation" />
            </v-chip>
          </template>
          <span v-else>全て</span>
        </v-flex>
      </v-layout>
      <v-layout pl-4>
        <v-flex xs3>
          <v-subheader class="subtitle-2">婚姻関係</v-subheader>
        </v-flex>
        <v-flex xs9 align-self-center>
          <v-chip v-if="demographic.marriage" small outline color="blue">
            <AppMarriage :value="demographic.marriage" />
          </v-chip>
          <span v-else>全て</span>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout column>
      <v-subheader>配信曜日時間帯設定</v-subheader>
      <v-layout pl-4 wrap>
        <v-flex xs2>
          <div class="bold-2 font-weight-bold">配信時間帯</div>
        </v-flex>
        <v-flex xs10>
          {{ schedule.startHour }} :00 〜 {{ schedule.endHour }} :59
        </v-flex>
      </v-layout>
    </v-layout>
  </Section>
</template>

<script>
import Section from './SimulationContentAdvancedConfirmSection'

export default {
  name: 'SimulationContentAdvancedConfirm',
  components: { Section },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    schedule() {
      const [schedule] = this.form.deliveryTimeSchedules
      const { startHour, endHour } = schedule
      return {
        startHour,
        endHour,
      }
    },
    demographic() {
      return this.form.demographicSetting
    },
  },
}
</script>

<style></style>
